import { FullProject } from 'entities';
import { ClosureFormData } from './types';

export function validateServicesAreFilled(
  project: FullProject,
  services: ClosureFormData['servicesActualMetrics'],
): boolean {
  return services.every(({ costs, id }) =>
    Object.entries(costs).every(([country, variables]) => {
      const valuesAreOk = variables.every(({ value, differenceJustification }, index) => {
        if (!value) return false;

        const currentValue = project.services.find((service) => service.id === id)?.costs[country][
          index
        ].value;

        const numeric = Number(value);

        const requiresJustification = Number(currentValue) !== numeric;

        const ok = [
          numeric >= 0,
          requiresJustification ? !!differenceJustification?.trim() : true,
        ].every(Boolean);

        return ok;
      });

      return valuesAreOk;
    }),
  );
}

export function validateCanFinish(
  project: FullProject,
  {
    comment,
    emailChainAddition,
    outsourceEmailControl,
    poNumber,
    servicesActualMetrics,
    canceledTasksPriceCheckControl,
  }: ClosureFormData,
): boolean {
  const isValid = [
    comment,

    emailChainAddition,

    poNumber.value,

    outsourceEmailControl.every(({ added }) => added),

    Object.values(canceledTasksPriceCheckControl).every(Boolean),

    validateServicesAreFilled(project, servicesActualMetrics),
  ].every(Boolean);

  return isValid;
}
